import React from "react";
import { useTranslation } from "react-i18next";

// Spectral balance bar showing low/mid/high energy vs target
export default function SpectralBar({ current, target }) {
  const { t } = useTranslation();
  const bands = [
    { key: "low", label: t("analysis.band_low"), color: "#3b82f6", range: "20–250 Hz" },
    { key: "mid", label: t("analysis.band_mid"), color: "#f59e0b", range: "250 Hz–4 kHz" },
    { key: "high", label: t("analysis.band_high"), color: "#ec4899", range: "4–16 kHz" },
  ];

  return (
    <div className="card p-5 flex flex-col gap-4">
      <div>
        <div className="tiny-caps">{t("analysis.spectral_bar_title")}</div>
        <div className="text-sm text-[color:var(--fg-secondary)] mt-1">
          {t("analysis.spectral_bar_subtitle")}
        </div>
      </div>
      <div className="flex flex-col gap-4">
        {bands.map((b) => {
          const cur = (current?.[b.key] ?? 0) * 100;
          const tgt = (target?.[b.key] ?? 0) * 100;
          return (
            <div key={b.key} className="flex flex-col gap-1.5">
              <div className="flex items-center justify-between text-xs">
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full" style={{ background: b.color }} />
                  <span className="text-white font-medium">{b.label}</span>
                  <span className="text-[color:var(--fg-muted)] tiny-caps text-[10px]">{b.range}</span>
                </div>
                <div className="metric-value text-white">
                  {cur.toFixed(1)}%
                  <span className="text-[color:var(--fg-muted)] ml-2">
                    tgt {tgt.toFixed(1)}%
                  </span>
                </div>
              </div>
              <div className="relative h-2 rounded-full bg-white/5">
                <div
                  className="absolute inset-y-0 left-0 rounded-full opacity-90"
                  style={{
                    width: `${Math.min(100, cur)}%`,
                    background: b.color,
                    transition: "width 0.9s cubic-bezier(0.2,0.7,0.2,1)",
                  }}
                />
                <div
                  className="absolute inset-y-0 w-[2px] bg-white/70"
                  style={{ left: `${Math.min(100, tgt)}%` }}
                  title={`Target ${tgt.toFixed(1)}%`}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
